import { Epic } from 'redux-observable';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { ofType } from '@alycecom/utils';
import { handleError, handlers, IResponse } from '@alycecom/services';

import { getHasIntegration } from '../statuses/statuses.selectors';

import { fetchBookedMeetingInfo } from './bookedMeetingInfo.actions';
import { TBookedMeetingInfoResponse } from './bookedMeetingInfo.types';

export const fetchBookedMeetingInfoEpic: Epic = (action$, state$, { apiService }) =>
  action$.pipe(
    ofType(fetchBookedMeetingInfo.pending),
    withLatestFrom(state$),
    switchMap(([{ payload: hashId }, state]) => {
      const hasIntegration = getHasIntegration(state);
      return apiService.get(`/api/recipient/${hashId}/booked-meeting-info`, null).pipe(
        map((response: IResponse<TBookedMeetingInfoResponse | null>) =>
          fetchBookedMeetingInfo.fulfilled({ ...response, hasIntegration }),
        ),
        catchError(handleError(handlers.handleAnyError(fetchBookedMeetingInfo.rejected()))),
      );
    }),
  );

export const bookedMeetingInfoEpics = [fetchBookedMeetingInfoEpic];
